// lib/skin.js — gerenciador de SKIN one-button (decisão 04/07/2026).
// Skin ≠ tema claro/escuro: skin troca a identidade inteira via html[data-skin]
// Sobra uma única skin (motion). Os CSS das skins descontinuadas foram removidos em 14/07.
//
// Uso:
//   import { bootSkin, cycleSkin, currentSkin } from './lib/skin.js';
//   bootSkin();                      // no main.js, ANTES do primeiro render
//   btn.addEventListener('click', cycleSkin);
//   window.addEventListener('theme:changed', ...) // charts re-renderizam

const KEY = 'angular-skin';
// 'motion' = padrão (sem data-skin, tokens-motion puros)
// 11/07: avaliação de design system encerrada — o shadcn venceu e virou a casca.
// Sobra UMA skin: o tema padrão (claro/escuro pelo botão sol/lua).
export const SKINS = [
  { id: 'motion', label: 'Tema Padrão' },
];

export function currentSkin() {
  return document.documentElement.dataset.skin || 'motion';
}

export function applySkin(id, { silent = false } = {}) {
  const known = SKINS.some((s) => s.id === id);
  if (!known) id = 'motion';
  if (id === 'motion') {
    delete document.documentElement.dataset.skin;
    // restaura a preferência claro/escuro do usuário (o toggle sol/lua volta a valer)
    try {
      const t = localStorage.getItem('angular-theme');
      const prefersLight = window.matchMedia?.('(prefers-color-scheme: light)').matches;
      document.documentElement.classList.toggle('light', t ? t === 'light' : !!prefersLight);
    } catch (_) {}
  } else {
    document.documentElement.dataset.skin = id;
    // Liquid Glass é DARK por natureza (kit iOS 26): html.light criaria estado
    // híbrido (tokens dark × ~450 regras literais html.light do canonical).
    document.documentElement.classList.remove('light');
  }
  try { localStorage.setItem(KEY, id); } catch (_) {}
  if (!silent) {
    try { window.dispatchEvent(new CustomEvent('theme:changed', { detail: { skin: id } })); } catch (_) {}
  }
  return id;
}

export function cycleSkin() {
  const i = SKINS.findIndex((s) => s.id === currentSkin());
  const next = SKINS[(i + 1) % SKINS.length];
  const applied = applySkin(next.id);
  try {
    import('./toast.js').then(({ showToast }) => showToast('Skin: ' + next.label, 'info')).catch(() => {});
  } catch (_) {}
  return applied;
}

export function bootSkin() {
  let saved = 'motion';
  try { saved = localStorage.getItem(KEY) || 'motion'; } catch (_) {}
  applySkin(saved, { silent: true }); // sem evento: ainda não há charts montados
}
